import { RootState } from "../types";

export const getMainShopSelector = (state: RootState) => state.shop